import React from "react";
import { FLoatLabelInputLayout } from "./InputLayout";
import { InputTextarea } from "primereact/inputtextarea";

const CustomInputTextArea = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  placeholder = "",
  rows = 5,
  cols = 30,
  ...props
}) => {
  return (
    <FLoatLabelInputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
    >
      <InputTextarea
        id={name}
        name={name}
        value={value || data?.[name] || ""}
        onChange={(e) =>
          onChange &&
          onChange({ ...e, name: e.target.name, value: e.target.value })
        }
        className={`input w-full border-round-lg ${inputClass ? inputClass : ""
          } ${errorMessage ? "p-invalid" : ""}`}
        placeholder={placeholder || `${label}`}
        disabled={disabled}
        rows={rows}
        cols={cols}
        {...props}
      />
    </FLoatLabelInputLayout>
  );
};

export default CustomInputTextArea;